export default __webpack_public_path__ + "static/media/billreynolds_between_fields.8f4b9f13.jpg";